<script>
import { Helper } from '@/mixin/helper'
import McGrapqlTable from '@/components/McGrapqlTable'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header'
import { GET_SENSOR_PAGINATED, UPDATE_SENSOR_PAGINATED } from '@/services/api/setting/sensor'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import { SENSOR_CODES } from '../lib/sensors'

export default {
  components: {
    McGrapqlTable,
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
  },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      form: {
        alertHi: 7,
        alertIdleHi: 0,
        alertIdleLo: 0,
        alertLo: 7,
        alertMinTime: 0,
        rangeHi: 0,
        rangeLo: 0,
        requireEngine: true,
      },
      idChecked: [],
      isUpdated: false,
      tableKey: 1,
    }
  },
  computed: {
    refuelingStatePercent() {
      return this.refuelingState
        ? Number(this.form.alertHi) >= 1 && Number(this.form.alertHi) <= 100
        : true
    },
    fuelLossStatePercent() {
      return this.fuelLossState
        ? Number(this.form.alertLo) >= 1 && Number(this.form.alertLo) <= 100
        : true
    },
    isValidModal() {
      return this.refuelingStatePercent && this.fuelLossStatePercent
    },
    title() {
      return this.$t('setting.list.trackerSensor.fuel')
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
    }),
    items() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: { name: 'Setting' },
        },
        {
          text: this.$t('setting.list.trackerSensor.trackerSensor'),
          to: { name: 'Setting Tracker & Sensor' },
        },
        {
          text: this.$t('setting.list.trackerSensor.fuel'),
          active: true,
        },
      ]
    },
    /**
     * Management Field for b-table
     */
    fields() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('setting.list.fleetGroup.form.licensePlate'),
          thClass: 'mc-table--150',
          isSortable: true,
          isEditable: false,
        },
        {
          key: 'refuelingLimit',
          label: `${this.$t('setting.list.trackerSensor.refuelingLimit')} (%)`,
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fuelLossLimit',
          label: `${this.$t('setting.list.trackerSensor.fuelLossLimit')} (%)`,
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'tankCapacity',
          label: `${this.$t('setting.list.trackerSensor.tankCapacity')} (L)`,
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fullTankLimit',
          label: `${this.$t('setting.list.trackerSensor.fullTankLimit')} (Cm)`,
          thClass: 'mc-table--200',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'emptyTankLimit',
          label: `${this.$t('setting.list.trackerSensor.emptyTankLimit')} (Cm)`,
          thClass: 'mc-table--200',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'imei',
          label: this.$t('setting.list.trackerSensor.imei'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fleetGroup',
          label: this.$t('setting.list.trackerSensor.fleetGroup'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fleetCategory',
          label: this.$t('setting.list.fleetSetting.fleetCategory'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
        {
          key: 'fleetType',
          label: this.$t('setting.list.fleetSetting.fleetType'),
          thClass: 'mc-table--150',
          isSortable: false,
          isEditable: false,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          filter.sensorCode = SENSOR_CODES.FUEL
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_SENSOR_PAGINATED,
            variables: {
              filter: filter,
            },
          })
          let result = res.data.sensorsPaginated.sensorsPaginated
          result.data.forEach((item, index) => {
            const vgroups = item.vehicleGroup
            const nameGroups = vgroups.map((item) => item.name)
            result.data[index].vgroups = nameGroups.join(', ')
          })
          return result
        },
      }
    },
  },
  methods: {
    openModal() {
      this.form = {
        alertHi: 7,
        alertLo: 7,
      }
      this.$bvModal.show('parameter-fuel')
    },

    applyParameter() {
      this.$bvModal.show('mc-modal-confirm')
    },

    async submitParameter() {
      this.isUpdated = true
      this.$bvModal.hide('parameter-fuel')
      this.$bvModal.hide('mc-modal-confirm')
      const input = {
        id: this.idChecked,
        newData: {
          alertHi: Number(this.form.alertHi),
          alertLo: Number(-this.form.alertLo),
        },
      }
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SENSOR_PAGINATED,
        variables: {
          input: input,
        },
      })
      const message = res.data.updateSensors.message
      this.isUpdated = false
      this.idChecked = []
      if (message == 'Successful') {
        this.tableKey += 1
        this.$mcToast.success(this.$t('global.alert.text.changed'))
      } else {
        this.$mcToast.error(this.$t('global.alert.text.failChange'))
      }
    },

    handleCheckbox(ids) {
      const resultKey = []
      const keys = Object.keys(ids)
      keys.forEach((item) => {
        if (ids[item]) resultKey.push(item)
      })
      this.idChecked = resultKey
    },

    onRowClicked(item) {
      if (!this.hasAccessAll(['set_fuel:read', 'set_fuel:update'])) {
        return
      }
      this.$router.push({
        name: 'Update Fuel Sensor Setting',
        params: { id: item.id },
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="mc-page-three" />
    <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
      <div class="float-end">
        <McButtonBack href="/setting/tracker-sensor/" />
      </div>
      <div class="item-right my-5 py-1">
        <div class="d-flex my-3">
          <McButton
            variant="secondary"
            class="mx-2"
            hidden
            :text="$t('report.object.filter')"
            icon="icon-outline_funnel"
          />

          <McButton
            v-if="hasAccess(['set_fuel:update'])"
            variant="secondary"
            class="mx-2"
            :disabled="isUpdated || idChecked.length <= 0"
            :text="$t('setting.list.trackerSensor.setParameter')"
            @click="openModal()"
          >
            <template #before-slot>
              <b-spinner v-if="isUpdated" small label="Small Spinner" />
            </template>
          </McButton>
        </div>
      </div>
    </div>

    <div class="py-5">
      <!-- Table -->
      <div class="datatables table-responsive my-3">
        <McGrapqlTable
          :key="tableKey"
          :apiClient="query"
          :fields="fields"
          :hasCheckbox="true"
          :searchable="true"
          :withCard="true"
          :isSelectableField="false"
          :hasDelete="false"
          trackBy="id"
          @handleSelectValue="handleCheckbox"
        >
          <template #cell(licensePlate)="data">
            <strong class="text-primary" @click="onRowClicked(data.item)">
              {{ data.item.vehicle.licensePlate }}
            </strong>
          </template>
          <template #cell(refuelingLimit)="data">
            {{ data.item.alertHi ?? 0 }}
          </template>
          <template #cell(fuelLossLimit)="data">
            {{ Math.abs(data.item.alertLo) ?? 0 }}
          </template>
          <template #cell(tankCapacity)="data">
            {{ data.item.vehicle.fuelCapacity ?? 0 }}
          </template>
          <template #cell(fullTankLimit)="data">
            {{ data.item.rangeHi?.toFixed(2) ?? 0 }}
          </template>
          <template #cell(emptyTankLimit)="data">
            {{ data.item.rangeLo?.toFixed(2) ?? 0 }}
          </template>
          <template #cell(imei)="data">
            {{ data.item.vehicle.imei }}
          </template>
          <template #cell(fleetGroup)="data">
            {{ data.item.vgroups }}
          </template>
          <template #cell(fleetCategory)="data">
            {{ data.item.vehicleType.category }}
          </template>
          <template #cell(fleetType)="data">
            {{ data.item.vehicleType.type }}
          </template>
        </McGrapqlTable>
      </div>
    </div>

    <b-modal id="parameter-fuel" centered :title="$t('global.setParameter')">
      <div class="d-flex align-items-start background-info-primary p-2">
        <i class="mc-fa icon-fill_info icon-primary icon-sm" />
        <p class="m-0 px-2">
          {{ $t('setting.list.trackerSensor.idleParkingModalInfo') }}
        </p>
      </div>
      <FormulateForm v-model="form">
        <FormulateInput
          id="refueling"
          name="alertHi"
          suffix
          :label="$t('setting.list.trackerSensor.refueling')"
          :placeholder="$t('setting.list.trackerSensor.refueling')"
          validation="^required|min:1|max:100|number"
          help="required"
          :validation-messages="{
            required: $t('global.validation.required'),
            min: $t('setting.list.trackerSensor.validator.percentage'),
            max: $t('setting.list.trackerSensor.validator.percentage'),
          }"
          class="my-3"
          validation-behavior="live"
          error-behavior="live"
        >
          <template #suffix>
            <div class="formulate-input-suffix">
              <span>%</span>
            </div>
          </template>
        </FormulateInput>
        <FormulateInput
          id="fuelLoss"
          name="alertLo"
          :label="$t('setting.list.trackerSensor.fuelLoss')"
          :placeholder="$t('setting.list.trackerSensor.fuelLoss')"
          suffix
          validation="^required|min:1|max:100|number"
          help="required"
          :validation-messages="{
            required: $t('global.validation.required'),
            min: $t('setting.list.trackerSensor.validator.percentage'),
            max: $t('setting.list.trackerSensor.validator.percentage'),
          }"
          class="my-3"
          validation-behavior="live"
          error-behavior="live"
        >
          <template #suffix>
            <div class="formulate-input-suffix">
              <span>%</span>
            </div>
          </template>
        </FormulateInput>
      </FormulateForm>

      <template #modal-footer="{ cancel }">
        <McButton
          size="md"
          variant="secondary"
          :text="$t('global.action.cancel')"
          @click="cancel()"
        />
        <McButton
          size="md"
          variant="primary"
          :text="$t('global.action.apply')"
          :disabled="!isValidModal"
          @click="applyParameter"
        />
      </template>
    </b-modal>
    <b-modal
      id="mc-modal-confirm"
      class="mc-modal"
      :title="$t('global.setParameter')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          {{ $t('global.setParameterConfirm') }}
          <strong>{{ idChecked.length }}</strong> {{ $t('global.confirmDelete2') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <McButton size="md" variant="secondary" :text="$t('global.action.no')" @click="cancel()" />
        <McButton
          size="md"
          variant="primary"
          :text="$t('global.action.yes')"
          @click="submitParameter"
        />
      </template>
    </b-modal>
  </Layout>
</template>
